import {
  RGBAFormat,
  RGBA_BPTC_Format,
  RGBA_ASTC_4x4_Format,
  RGB_S3TC_DXT1_Format,
  RGBA_S3TC_DXT5_Format,
  RGB_PVRTC_4BPPV1_Format,
  RGBA_PVRTC_4BPPV1_Format,
  RGB_ETC1_Format,
  RGB_ETC2_Format,
  RGBA_ETC2_EAC_Format
} from 'three';


export class Utils {
  static getTextureFormat(texture) {
    const formatStrings = {
      [ RGBAFormat ]: 'RGBA32',
      [ RGBA_BPTC_Format ]: 'RGBA_BPTC',
      [ RGBA_ASTC_4x4_Format ]: 'RGBA_ASTC_4x4',
      [ RGB_S3TC_DXT1_Format ]: 'RGB_S3TC_DXT1',
      [ RGBA_S3TC_DXT5_Format ]: 'RGBA_S3TC_DXT5',
      [ RGB_PVRTC_4BPPV1_Format ]: 'RGB_PVRTC_4BPPV1',
      [ RGBA_PVRTC_4BPPV1_Format ]: 'RGBA_PVRTC_4BPPV1',
      [ RGB_ETC1_Format ]: 'RGB_ETC1',
      [ RGB_ETC2_Format ]: 'RGB_ETC2',
      [ RGBA_ETC2_EAC_Format ]: 'RGB_ETC2_EAC',
    };

    return formatStrings[texture.format];
  }
}
